import { createActionCreator } from '@pressreader/appstore';
import type { ArticleCollectionIds, ArticleCollections } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';

const pre = MODULE_NAME + '/article_collections/';

export interface WithArticleId {
    articleId: string;
}

export interface LoadArticleCollectionsDonePayload extends WithArticleId {
    collections: ArticleCollections | undefined;
}

export interface LoadArticleCollectionsFailedPayload extends WithArticleId {
    error: unknown;
}

const loadArticleCollectionsAction = createActionCreator<
    WithArticleId & {
        /**
         * @default false
         */
        isForce?: boolean;
    }
>(`${pre}load_article_collections_action`);

const loadArticleCollectionsBegan = createActionCreator<WithArticleId>(`${pre}load_article_collections_began`);
const loadArticleCollectionsDone = createActionCreator<LoadArticleCollectionsDonePayload>(`${pre}load_article_collections_done`);
const loadArticleCollectionsFailed = createActionCreator<LoadArticleCollectionsFailedPayload>(`${pre}load_article_collections_failed`);
const loadArticleCollectionsCancelled = createActionCreator<WithArticleId>(`${pre}load_article_collections_cancelled`);
const resetArticleCollectionsAction = createActionCreator<WithArticleId>(`${pre}reset_article_collections`);

const upsertArticleCollectionsAction = createActionCreator<
    WithArticleId & {
        collectionsData: ArticleCollectionIds;
    }
>(`${pre}upsert_article_collections_action`);
const upsertArticleCollectionsBegan = createActionCreator<WithArticleId>(`${pre}upsert_article_collections_began`);
const upsertArticleCollectionsDone = createActionCreator<
    WithArticleId & {
        articleCollections: ArticleCollections;
    }
>(`${pre}upsert_article_collections_done`);
const upsertArticleCollectionsFailed = createActionCreator<WithArticleId>(`${pre}upsert_article_collections_failed`);

const removeArticleFromCollectionsAction = createActionCreator<WithArticleId>(`${pre}remove_article_from_collections_action`);
const removeArticleFromCollectionsBegan = createActionCreator<WithArticleId>(`${pre}remove_article_from_collections_began`);
const removeArticleFromCollectionsDone = createActionCreator<WithArticleId>(`${pre}remove_article_from_collections_done`);
const removeArticleFromCollectionsFailed = createActionCreator<WithArticleId>(`${pre}remove_article_from_collections_failed`);

const loadArticleCollectionsFinishedActionList = Object.freeze([
    loadArticleCollectionsDone,
    loadArticleCollectionsFailed,
    loadArticleCollectionsCancelled,
    upsertArticleCollectionsDone,
    upsertArticleCollectionsFailed,
    removeArticleFromCollectionsDone,
    removeArticleFromCollectionsFailed,
]);

export {
    loadArticleCollectionsBegan,
    loadArticleCollectionsDone,
    loadArticleCollectionsFailed,
    resetArticleCollectionsAction,
    loadArticleCollectionsAction,
    loadArticleCollectionsCancelled,
    loadArticleCollectionsFinishedActionList,
    upsertArticleCollectionsAction,
    upsertArticleCollectionsBegan,
    upsertArticleCollectionsDone,
    upsertArticleCollectionsFailed,
    removeArticleFromCollectionsAction,
    removeArticleFromCollectionsBegan,
    removeArticleFromCollectionsDone,
    removeArticleFromCollectionsFailed,
};
